import { combineReducers } from '@reduxjs/toolkit';
import SealinkReducer from './sealink_reducer';

export default combineReducers({
  sealink: SealinkReducer,
});
